import styled from 'styled-components';

export const PositionsContainer = styled.div`
  padding: 5px 15px 10px;

  .sub-tab > .shell-tabs-nav {
    border-bottom: 1px solid ${(props) => props.theme.border.medium};
  }

  .content {
    padding: 24px 0;
  }
`;
